import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'jeopardy-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    standalone: true
})
export class LogoComponent implements OnInit {
  
  ngOnInit(): void {
  }

}
